import { Component, Input, OnInit } from '@angular/core';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'business-card',
  templateUrl: './business-card.component.html',
  styleUrls: ['./business-card.component.scss'],
})
export class BusinessCardComponent implements OnInit {
  @Input() contactInfo;
  @Input() border = true;

  ngOnInit(): void {
    const [contactInfo] = checkInputsForText([this.contactInfo]);

    this.contactInfo = contactInfo;
  }
}
